import { Component, OnInit } from '@angular/core';
import { DirectlySentConsultNotesComponent } from '../../../captures/components/directly-sent-consult-notes/directly-sent-consult-notes.component';

@Component({
    selector: 'app-client-portal-direct-consult-notes',
    templateUrl: './client-portal-direct-consult-notes.component.html',
    styleUrls: ['./client-portal-direct-consult-notes.component.scss'],
    imports: [DirectlySentConsultNotesComponent]
})
export class ClientPortalDirectConsultNotesComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
